const topics = [
  { id: 1, name: '星球大战漫画', heat: '2.3 万讨论', icon: 'ri-star-smile-line' },
  { id: 2, name: '免费在线漫画推荐', heat: '1.8 万讨论', icon: 'ri-thumb-up-line' },
  { id: 3, name: '星际冒险漫画排行', heat: '1.5 万讨论', icon: 'ri-medal-line' },
  { id: 4, name: '好看的科幻漫画', heat: '1.4 万讨论', icon: 'ri-eye-line' },
  { id: 5, name: '宇宙漫画全集', heat: '1.2 万讨论', icon: 'ri-bookmark-line' },
  { id: 6, name: '下拉式阅读漫画', heat: '9,800 讨论', icon: 'ri-scroll-to-bottom-line' },
  { id: 7, name: '科幻新作速递', heat: '8,500 讨论', icon: 'ri-rocket-line' },
  { id: 8, name: '太空冒险漫画', heat: '7,200 讨论', icon: 'ri-space-ship-line' },
  { id: 9, name: '漫画创作交流', heat: '6,800 讨论', icon: 'ri-paint-brush-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            加入讨论，和百万星际漫画迷一起畅聊
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="flex items-center gap-3 bg-background-100 rounded-lg p-3 md:p-4 border border-background-200/60 hover:border-primary-300/50 transition-colors no-underline cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-accent-50 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-100 transition-colors">
                <i className={`${topic.icon} text-accent-500 text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-0.5 group-hover:text-primary-600 transition-colors whitespace-nowrap truncate">
                  {topic.name}
                </h3>
                <p className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-fire-line text-primary-500 text-xs"></i>
                  </span>
                  {topic.heat}
                </p>
              </div>
              <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-300">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}